module.exports = __webpack_public_path__ + "img/star5.8c38f502.png";